import { render } from "./TipPoolShareTable.vue?vue&type=template&id=80014546"
import script from "./TipPoolShareTable.vue?vue&type=script&lang=js"
export * from "./TipPoolShareTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__